import React from 'react'
import { Box, Container, Fade, Paper, Step, StepLabel, Stepper, Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import InfoStep1 from './InfoStep1'
import InfoStep2 from './InfoStep2'
import InfoSchoolStructure from './InfoSchoolStructure'

const steps = [
  {
    header: 'Just_3_steps_away_from_creating_your_site',
    title: 'about_your_institution',
    Component: InfoStep1,
  },
  {
    header: 'Just_2_steps_away_from_creating_your_site',
    title: 'your_school_structure',
    Component: InfoSchoolStructure,
  },
  {
    header: 'One_last_step_to_create_your_site',
    title: 'personal_info',
    Component: InfoStep2,
  },
]

function AccountInfoSection({ data, setData, handleBack, handleNext }) {
  const { t } = useTranslation()
  const [active, setActive] = React.useState(0)
  const next = () => {
    if (active < steps.length - 1) setActive(active + 1)
    else handleNext()
  }
  const back = () => {
    if (active > 0) setActive(active - 1)
    else handleBack()
  }

  return (
    <Box pb={6}>
      <Container maxWidth="md">
        <Box
          p={3}
          sx={{ backgroundColor: 'primary.main', color: 'primary.contrastText' }}
        >
          <Typography
            display="block"
            textAlign="center"
          >
            {t(`register:account_info.${steps[active].header}`)}
          </Typography>
        </Box>
        <Paper sx={{ borderRadius: 4, borderTopRightRadius: 0, borderTopLeftRadius: 0 }}>
          <Box
            py={{ xs: 4, md: 5 }}
            px={{ xs: 3, md: 8 }}
          >
            <Stepper
              activeStep={active}
              alternativeLabel
            >
              {steps.map(({ title }, index) => (
                <Step
                  key={index}
                  sx={{
                    '.MuiStepConnector-root': {
                      top: '25px',
                      left: 'calc(-50% + 25px)',
                      right: 'calc(50% + 25px)',
                    },
                    '.MuiStepIcon-text': {
                      fontFamily: 'var(--cairo-font)',
                      fill: (theme) => (active === index ? theme.palette.primary.main : 'white'),
                      fontSize: 12,
                      color: 'white !important',
                    },
                    '.MuiStepLabel-label': {
                      fontSize: { xs: 13, sm: 17 },
                    },
                    '.MuiSvgIcon-root': {
                      transform: 'scaleX(1) !important',
                      border: '2px solid',
                      borderColor: active === index ? 'primary.main' : 'transparent',
                      color:
                        // eslint-disable-next-line no-nested-ternary
                        active === index
                          ? 'white !important'
                          : active > index
                          ? 'primary.main'
                          : '#C4C4C4',
                      borderRadius: '50%',
                    },
                  }}
                >
                  <StepLabel
                    color="primary.main"
                    StepIconProps={{
                      sx: {
                        fontFamily: 'Cairo !important',
                        fontSize: 50,
                      },
                    }}
                    sx={{ textTransform: 'capitalize' }}
                  >
                    {t(`register:account_info.${title}`)}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
            <Box mt={6}>
              {steps.map(({ Component }, index) => (
                <Fade
                  key={index}
                  in={active === index}
                  sx={{ display: active === index ? '' : 'none' }}
                >
                  <Box>
                    <Component
                      handleNext={next}
                      handleBack={back}
                      data={data}
                      setData={setData}
                    />
                  </Box>
                </Fade>
              ))}
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}

export default AccountInfoSection
